import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { UserRole } from '../../types/enums';
// Removed direct Firestore imports - using secure server functions instead

export const fetchAvailableUsers = createAsyncThunk(
  'users/fetchAvailable',
  async ({ facilityId = null } = {}, { getState, rejectWithValue }) => {
    try {
      const state = getState();
      const currentUser = state.auth.user;

      if (!currentUser) {
        throw new Error('No authenticated user found');
      }

      // Use secure server function instead of direct Firestore queries
      const { getUsers } = await import('../../services/userService');
      
      // Get users with proper server-side security validation
      // Server function handles admin vs facility admin permissions automatically
      const result = await getUsers(facilityId, 1, 1000); // Get up to 1000 users
      
      // Filter for healthcare roles only (additional client-side filter for UX)
      const healthcareRoles = [UserRole.DOCTOR, UserRole.NURSE, UserRole.ADMIN, UserRole.FACILITY_ADMIN, UserRole.ATTENDING_PHYSICIAN];
      const availableUsers = result.users.filter(user => {
        const userRoles = user.roles || [user.role];
        return userRoles.some(role => healthcareRoles.includes(role));
      });

      return availableUsers;

    } catch (error) {
      console.error('Error fetching available users:', error);
      return rejectWithValue(error.message);
    }
  }
);

const usersSlice = createSlice({
  name: 'users',
  initialState: {
    availableUsers: [],
    loading: false,
    error: null
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAvailableUsers.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAvailableUsers.fulfilled, (state, action) => {
        state.availableUsers = action.payload;
        state.loading = false;
      })
      .addCase(fetchAvailableUsers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export default usersSlice.reducer;
